
/**
 * キーワード検索
 **/

(function() {
    'use strict';
    

    let obj_elements = '';
    let obj_tbody = '';
    let table_length = 0;

    

    let init = () => {
        let required_class = document.getElementsByClassName("search-container");
        if (required_class.length > 0) {
            obj_elements = readElement();
            table_length = Object.keys(obj_elements.table).length;
            obj_tbody = readTable();
            createTexts();
            enableEvent();
        }
    }

    // tdをtextにまとめる
    let createTexts = () => {
        for(let i = 0; i < table_length; ++i){
            let tbody = obj_tbody[i];
            for(let z = 0; z < tbody.length; ++z){
                let td = tbody[z].td;
                let text = '';
                for(let x = 0; x < td.length; ++x){
                   text += td[x].textContent;
                }
                obj_tbody[i][z].td = text;
            }
        }
    }

    // 該当するtr,tdをまとめる
    let readTable = () => {
        let result = [];
        for(let i = 0; i < table_length; ++i){
            result[i] = [];
            let tr_idx = 0;
            let table = obj_elements.table[i];
            let tbody = table.getElementsByTagName('tbody')[0];
            let in_table = table.getElementsByTagName('table');
            for(let z = 0; z < in_table.length; ++z){
                in_table[z].classList.add('filter-exclusive');
                let in_tr = in_table[z].getElementsByTagName('tr');
                for(let y = 0; y < in_tr.length; ++y){
                    in_tr[y].classList.add('filter-tr-exclusive');
                }
            }

            let tr = tbody.getElementsByTagName('tr');
            for(let x = 0; x < tr.length; ++x){
                let exclusive_tr = tr[x].classList.contains('filter-tr-exclusive');
                if(exclusive_tr === false){
                    let td = tr[x].getElementsByTagName('td') || '';
                    result[i][tr_idx] = {'tr':tr[x],'td':td};
                    ++tr_idx;
                }
            }
        }
        return result;
    }

    // イベントリスナーを作成
    let enableEvent = () => {
        let input_length = Object.keys(obj_elements.input).length;
        let table_length = Object.keys(obj_elements.table).length;

        if(input_length === 0 || 
            table_length === 0 || 
            input_length !== table_length){
            return;
        }

        let tableSearch = (keyword,idx) => {
            //const regExp = new RegExp(keyword);

            let tbody = obj_tbody[idx];
            for(let z = 0; z < tbody.length; ++z){
                let filter_str = tbody[z].tr.dataset.filter || '';
                let text = tbody[z].td + filter_str;
                if (text.indexOf(keyword) !== -1) {
                    tbody[z].tr.classList.remove('table-search-tr-hide')
                    tbody[z].tr.classList.add('table-search-tr-show');
                } else {
                    tbody[z].tr.classList.remove('table-search-tr-show')
                    tbody[z].tr.classList.add('table-search-tr-hide');
                }
            }
        }
  
        for(let i = 0; i < input_length; i++){
            let input = obj_elements.input[i];
            input.addEventListener('input',(event) => {
                let keyword = event.currentTarget.value;
                tableSearch(keyword,i);
            },false);
        }        
    }

    // 該当するtableを全部取得、table内のtableは除外クラスを指定
    let readElement = () => {
        let result = {table:{}, input:{}};
        const obj_table = document.getElementsByClassName('search-table');
        let t_index = 0;
        for(let i = 0; i < obj_table.length; ++i){
            if(obj_table[i].tagName === 'DIV'){              
                result.table[t_index] = obj_table[i].getElementsByTagName('table')[0] || '';
            } else {
                result.table[t_index] = obj_table[i] || '';
            }            
            ++t_index;
        }

        t_index = 0;
        const search_ele = document.getElementsByTagName('div');        
        for(let i = 0; i < search_ele.length; ++i){
            if(search_ele[i].classList.contains('search-container') === true){                
                result.input[t_index] = search_ele[i].getElementsByTagName('input')[0] || '';
                ++t_index;
            }
        }
        return result;
    }

    document.addEventListener("DOMContentLoaded", ()=> init());

})();